import Vue from 'vue';
import GlobalToast from './Message.vue'; // 确保路径正确

let ToastConstructor = Vue.extend(GlobalToast); // 创建一个Vue的子类构造函数
let toast; // 全局唯一的Toast实例变量

function showToast(message, type) {
	if (!toast) { // 如果还没有实例，则创建一个新的实例并挂载到body上
		toast = new ToastConstructor({
			el: document.createElement('div')
		});
		document.body.appendChild(toast.$el); // 把toast的DOM挂载到body上，这样可以全局显示提示信息。
	}
	toast.show(message, type); // 调用实例的方法显示提示信息。
}

export default {
	install(Vue) {
		Vue.prototype.$toast = showToast;
	}
}